// import React from 'react';

// const CPDTable = ({ records }) => {
//   return (
//     <table>
//       <thead>
//         <tr>
//           <th>Title</th>
//           <th>Duration (hrs)</th>
//           <th>Date</th> {/* New Date Column */}
//           <th>Venue</th>
//           <th>Organized By</th>
//           <th>Conducted By</th>
//           <th>CPD Type</th>
//         </tr>
//       </thead>
//       <tbody>
//         {records.map((record, index) => (
//           <tr key={index}>
//             <td>{record.title}</td>
//             <td>{record.duration}</td>
//             <td>{new Date(record.date).toLocaleDateString()}</td> {/* Format the date */}
//             <td>{record.venue}</td>
//             <td>{record.organizedBy}</td>
//             <td>{record.conductedBy}</td>
//             <td>{record.cpdType}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

// export default CPDTable;


import React from 'react';

const CPDTable = ({ records }) => {
  return (
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Duration (hrs)</th>
         
          <th>Start Date</th> {/* New Start Date Column */}
          <th>End Date</th> {/* New End Date Column */}
          <th>Venue</th>
          <th>Organized By</th>
          <th>Conducted By</th>
          <th>CPD Type</th>
        </tr>
      </thead>
      <tbody>
        {records.map((record, index) => (
          <tr key={index}>
            <td>{record.title}</td>
            <td>{record.duration}</td>
           
            <td>{new Date(record.startDate).toLocaleDateString()}</td> {/* Format the start date */}
            <td>{record.endDate ? new Date(record.endDate).toLocaleDateString() : new Date(record.startDate).toLocaleDateString()}</td> {/* Format the end date */}
            <td>{record.venue}</td>
            <td>{record.organizedBy}</td>
            <td>{record.conductedBy}</td>
            <td>{record.cpdType}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CPDTable;